import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const CheckoutStep = () => {
  const [step, setStep] = useState(0);

  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* CHECKOUT STEPS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Checkout Steps</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Linear Stepper</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600">
              <div className="flex items-center justify-between">
                {["Cart", "Shipping", "Payment", "Confirm"].map((label, i) => (
                  <div key={label} className="flex flex-col items-center flex-1">
                    <div className={`w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm ${i <= 1 ? "bg-amber-600 text-white" : "bg-slate-700 text-slate-400"}`}>{i + 1}</div>
                    <p className="text-xs text-slate-400 mt-1 text-center">{label}</p>
                    {i < 3 && <div className={`w-full h-1 mt-1 ${i < 1 ? "bg-amber-600" : "bg-slate-700"}`}></div>}
                  </div>
                ))}
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`const steps = ["Cart", "Shipping", "Payment", "Submit"];
const [current, setCurrent] = useState(0);

<div className="flex items-center gap-2">
  {steps.map((s, i) => (
    <div key={i} className="flex items-center">
      <div className={current >= i ? "bg-amber-600" : "bg-slate-700"}>{i + 1}</div>
      {i < steps.length - 1 && <div className="w-8 h-1" />}
    </div>
  ))}
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Vertical Stepper</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600 space-y-2">
              {["Add Items", "Enter Address", "Review Order", "Pay"].map((label, i) => (
                <div key={i} className="flex gap-3">
                  <div className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0 ${i <= step ? "bg-amber-600 text-white" : "bg-slate-700 text-slate-400"}`}>{i + 1}</div>
                  <div>
                    <p className={`text-xs font-medium ${i <= step ? "text-slate-100" : "text-slate-400"}`}>{label}</p>
                    {i === step && <p className="text-xs text-amber-400 mt-1">In progress</p>}
                  </div>
                </div>
              ))}
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`{steps.map((s, i) => (
  <div key={i} className="flex gap-3">
    <div className={current >= i ? "bg-amber-600" : "bg-slate-700"}>
      {i + 1}
    </div>
    <div>
      <p>{s}</p>
      {i === current && <p className="text-amber-400">In progress</p>}
    </div>
  </div>
))}`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Progress with Actions</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600 space-y-3">
              <div className="flex items-center justify-between">
                {[1, 2, 3].map(i => <div key={i} className={`w-6 h-6 rounded-full ${i <= 2 ? "bg-amber-600" : "bg-slate-700"}`}></div>)}
              </div>
              <p className="text-xs text-slate-400 text-center">Step 2 of 3 - Payment</p>
              <div className="flex gap-2">
                <button className="flex-1 px-2 py-1 bg-slate-700 text-slate-300 text-xs rounded">Back</button>
                <button className="flex-1 px-2 py-1 bg-amber-600 text-white text-xs rounded">Next</button>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="space-y-3">
  <div className="flex gap-2">
    {[1, 2, 3].map(i => (
      <div key={i} className={current >= i ? "bg-amber-600 h-2" : "bg-slate-700 h-2"} />
    ))}
  </div>
  <p className="text-sm">Step {current} of 3</p>
  <div className="flex gap-2">
    <button onClick={() => setCurrent(Math.max(0, current - 1))}>Back</button>
    <button onClick={() => setCurrent(Math.min(2, current + 1))}>Next</button>
  </div>
</div>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Tab-based Progress</label>
            <div className="p-3 bg-slate-950 rounded border border-slate-600">
              <div className="flex gap-1 mb-3 bg-slate-800 p-1 rounded">
                {["Cart", "Ship", "Pay", "Done"].map((s, i) => (
                  <button key={i} className={`flex-1 px-2 py-1 text-xs rounded font-medium ${i <= 2 ? "bg-amber-600 text-white" : "bg-slate-700 text-slate-400"}`}>{s}</button>
                ))}
              </div>
              <p className="text-xs text-slate-400">Choose shipping method</p>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="flex gap-1 bg-slate-800 p-1 rounded">
  {steps.map((s, i) => (
    <button key={i} className={current >= i ? "bg-amber-600" : "bg-slate-700"} onClick={() => setCurrent(i)}>
      {s}
    </button>
  ))}
</div>`} />
          </div>
        </div>
      </div>

      {/* ADVANCED CHECKOUT */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Advanced Checkout</h2>
        <div className="grid grid-cols-1 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg overflow-hidden">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Multi-section Checkout</label>
            <div className="p-4 bg-slate-950 rounded border border-slate-600 space-y-3">
              <div className="space-y-2">
                <p className="text-xs font-bold text-slate-300">Billing Address</p>
                <div className="bg-slate-800 p-2 rounded text-xs text-slate-400 border-l-4 border-amber-600">Complete ?</div>
              </div>
              <div className="space-y-2">
                <p className="text-xs font-bold text-slate-300">Shipping Method</p>
                <div className="bg-slate-800 p-2 rounded text-xs text-slate-400 border-l-4 border-yellow-500">In Progress...</div>
              </div>
              <div className="space-y-2">
                <p className="text-xs font-bold text-slate-300">Payment</p>
                <div className="bg-slate-800 p-2 rounded text-xs text-slate-500 border-l-4 border-slate-600">Pending</div>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`const sections = [{name: "Billing", status: "complete"}, {name: "Shipping", status: "progress"}, {name: "Payment", status: "pending"}];

{sections.map(s => (
  <div key={s.name} className="space-y-2">
    <p className="font-bold">{s.name}</p>
    <div className={s.status === "complete" ? "border-l-4 border-amber-600" : s.status === "progress" ? "border-l-4 border-yellow-500" : "border-l-4 border-slate-600"}>
      {s.status}
    </div>
  </div>
))}`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutStep;


